<div class="pagination">
    <div class="status">
        Showing <strong>{{ startItem }}</strong> - <strong>{{ endItem }}</strong> of <strong>{{ totalItems }}</strong>
    </div>
    <div class="page-number">
        <button class="btn nav-btn" type="button" [class.disabled]="pageNumber == 1" [disabled]="pageNumber == 1"
            (click)="gotoPage(pageNumber-1)" aria-label="Previous page">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 11L5 7L9 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>

        @for (item of tempPagesArray; track $index) {
        @if (item != '...') {
        <button class="btn page" type="button" [class.active]="item == pageNumber" (click)="gotoPage(item)">
            {{item}}
        </button>
        }
        @else {
        <span class="btn ellipsis">…</span>
        }
        }

        <button class="btn nav-btn" type="button" [class.disabled]="pageNumber == totalPages"
            [disabled]="pageNumber == totalPages" (click)="gotoPage(pageNumber+1)" aria-label="Next page">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 3L9 7L5 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>
    </div>
</div>
